import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from '../components/header/header'

const User = () => {
  return (
    <>
    <Header />
     <div className="main-content-area">
        {<Outlet />}
      </div>
    </>
  )
}

export default User